var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint0_radial_3250_46991)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint1_radial_3250_46991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint2_radial_3250_46991)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2713 22.6168C14.4976 22.6168 17.1129 20.0015 17.1129 16.7752C17.1129 13.549 14.4976 10.9336 11.2713 10.9336C8.04507 10.9336 5.42969 13.549 5.42969 16.7752C5.42969 20.0015 8.04507 22.6168 11.2713 22.6168Z",
    fill: "url(#paint3_radial_3250_46991)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0554 22.7348C26.9855 22.7348 29.3608 20.3595 29.3608 17.4294C29.3608 14.4993 26.9855 12.124 24.0554 12.124C21.1253 12.124 18.75 14.4993 18.75 17.4294C18.75 20.3595 21.1253 22.7348 24.0554 22.7348Z",
    fill: "url(#paint4_radial_3250_46991)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0238 20.2805C15.9274 20.2805 18.2813 17.9267 18.2813 15.0231C18.2813 12.1195 15.9274 9.76562 13.0238 9.76562C10.1202 9.76562 7.76636 12.1195 7.76636 15.0231C7.76636 17.9267 10.1202 20.2805 13.0238 20.2805Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9604 20.3764C29.8904 20.3764 32.2658 18.0011 32.2658 15.071C32.2658 12.1409 29.8904 9.76562 26.9604 9.76562C24.0303 9.76562 21.655 12.1409 21.655 15.071C21.655 18.0011 24.0303 20.3764 26.9604 20.3764Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.75C15.8211 18.75 17.5 17.0711 17.5 15C17.5 12.9289 15.8211 11.25 13.75 11.25C11.6789 11.25 10 12.9289 10 15C10 17.0711 11.6789 18.75 13.75 18.75Z",
    fill: "url(#paint5_linear_3250_46991)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.75C28.3211 18.75 30 17.0711 30 15C30 12.9289 28.3211 11.25 26.25 11.25C24.1789 11.25 22.5 12.9289 22.5 15C22.5 17.0711 24.1789 18.75 26.25 18.75Z",
    fill: "url(#paint6_linear_3250_46991)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.75C13.125 24.5834 15.625 26.875 20 26.875C24.375 26.875 26.875 24.5834 27.5 23.75",
    stroke: "url(#paint7_radial_3250_46991)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3250_46991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.75 8.75) rotate(100.923) scale(36.2822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493469,
    stopColor: "#07B15D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C569"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3250_46991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 15.625) rotate(90) scale(24.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81119,
    stopColor: "#A7A1F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972655,
    stopColor: "#9BFF92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3250_46991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 17.5) rotate(135) scale(51.2652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3250_46991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8147 12.2317) rotate(135) scale(11.3822 5.89106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3250_46991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1818 13.3029) rotate(135) scale(9.5871 5.41207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3250_46991",
    x1: 20.625,
    y1: 10,
    x2: 19.375,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3250_46991",
    x1: 20.625,
    y1: 10,
    x2: 19.375,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3250_46991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 21.25) rotate(90) scale(7.5 11.4798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.517632,
    stopColor: "#4E2553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702876,
    stopColor: "#5B4852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2553"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPain);
export default __webpack_public_path__ + "static/media/noPain.cebd0aeb4b5e3e07b9af36c3ac38f40e.svg";
export { ForwardRef as ReactComponent };